__turbopack_context__.v({
  "action": "Home-module-scss-module__EJ4Mza__action",
  "avatar": "Home-module-scss-module__EJ4Mza__avatar",
  "encyclopedia-category": "Home-module-scss-module__EJ4Mza__encyclopedia-category",
  "rating": "Home-module-scss-module__EJ4Mza__rating",
  "review": "Home-module-scss-module__EJ4Mza__review",
  "review-list": "Home-module-scss-module__EJ4Mza__review-list",
  "social-proof": "Home-module-scss-module__EJ4Mza__social-proof",
  "trustpilot": "Home-module-scss-module__EJ4Mza__trustpilot",
  "trustpilot-card": "Home-module-scss-module__EJ4Mza__trustpilot-card",
  "trustpilot-container": "Home-module-scss-module__EJ4Mza__trustpilot-container",
  "what-section": "Home-module-scss-module__EJ4Mza__what-section",
});
